// frontend/src/analytics/analytics.js
const API_URL = process.env.REACT_APP_API_URL;

const VISITOR_ID_KEY = "elacoria_visitor_id";
const SESSION_ID_KEY = "elacoria_session_id";
const SESSION_LAST_ACTIVE_AT_KEY = "elacoria_session_last_active_at";

const SESSION_DURATION_MS = 30 * 60 * 1000;

function createId() {
  if (window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }

  return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

export function getVisitorId() {
  let visitorId = localStorage.getItem(VISITOR_ID_KEY);

  if (!visitorId) {
    visitorId = createId();
    localStorage.setItem(VISITOR_ID_KEY, visitorId);
  }

  return visitorId;
}

export function getSessionId() {
  const now = Date.now();

  let sessionId = sessionStorage.getItem(SESSION_ID_KEY);

  const lastActiveAt = Number(
    sessionStorage.getItem(SESSION_LAST_ACTIVE_AT_KEY) || 0,
  );

  const isExpired = !lastActiveAt || now - lastActiveAt > SESSION_DURATION_MS;

  if (!sessionId || isExpired) {
    sessionId = createId();
    sessionStorage.setItem(SESSION_ID_KEY, sessionId);
  }

  sessionStorage.setItem(SESSION_LAST_ACTIVE_AT_KEY, String(now));

  return sessionId;
}

export function getUtmParams() {
  const params = new URLSearchParams(window.location.search);

  return {
    utmSource: params.get("utm_source") || "",
    utmMedium: params.get("utm_medium") || "",
    utmCampaign: params.get("utm_campaign") || "",
    utmContent: params.get("utm_content") || "",
    utmTerm: params.get("utm_term") || "",
  };
}

export function getBasicMetadata(extraMetadata = {}) {
  return {
    url: window.location.href,
    path: window.location.pathname,
    search: window.location.search,
    title: document.title,
    language: navigator.language || "",
    screenWidth: window.screen?.width || 0,
    screenHeight: window.screen?.height || 0,
    viewportWidth: window.innerWidth || 0,
    viewportHeight: window.innerHeight || 0,
    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
    ...getUtmParams(),
    ...extraMetadata,
  };
}

export async function trackEvent(eventType, metadata = {}) {
  if (!API_URL) {
    return;
  }

  try {
    const payload = {
      visitorId: getVisitorId(),
      sessionId: getSessionId(),
      eventType,
      page: window.location.pathname || "/",
      referrer: document.referrer || "",
      userAgent: navigator.userAgent || "",
      metadata: getBasicMetadata(metadata),
    };

    await fetch(`${API_URL}/analytics/track`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
      keepalive: true,
    });
  } catch (error) {
    console.warn("Track event failed:", error);
  }
}

export function trackPageView(extraMetadata = {}) {
  return trackEvent("PAGE_VIEW", extraMetadata);
}

export function trackSocialClick(platform, href) {
  return trackEvent("SOCIAL_CLICK", {
    platform,
    href,
  });
}

export function trackSupportClick(source = "") {
  return trackEvent("SUPPORT_CLICK", {
    source,
  });
}

export function trackTrailerPlay(source = "hero") {
  return trackEvent("TRAILER_PLAY", {
    source,
  });
}

export function trackTrailerProgress(percent, source = "hero") {
  return trackEvent("TRAILER_PROGRESS", {
    source,
    percent,
  });
}

export function trackPackageSelect(packageId, packageName, price) {
  return trackEvent("PACKAGE_SELECT", {
    packageId,
    packageName,
    price,
  });
}

export function trackScrollDepth(percent) {
  return trackEvent("SCROLL_DEPTH", {
    percent,
  });
}
